import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class NewsletterActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Web/Newsletter/NewsletterBrowser")
	}

	render() {
		return (
			<Activity 
				name="Newsletter"
				RenderedComponent={this.RenderedComponent}
                context="Newsletter"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(NewsletterActivity)
